import BlogPage from 'src/views/Marketing/Blog/components/BlogPage';
import Footer from 'src/views/Marketing/components/Footer';
import NavBar from 'src/views/Marketing/components/NavBar';
import { ScrollView, StyleSheet } from 'react-native';

export default function Page() {
  return (
    <ScrollView style={styles.scrollView}>
      <NavBar />
      <BlogPage author='OneShop Team' dateTime='2021-11-20' tag='Depop' title='9 Tips for a Successful Depop Shop'>
        ​
        <p>
          If you're looking for essential tips and tricks to have a successful Depop shop, this blog post is for you.
          Here are nine tips and tricks that can help make your Depop shop more popular and get you more sales.{' '}
        </p>
        <h3>1. List Items Regularly</h3>
        <p>
          The first tip is simple: list items often! It can be as easy as scheduling listings in advance or making an
          effort to take photos when new things come in the mail. Not only does this encourage repeat customers, but it
          also allows shoppers to keep up with what's currently available in your shop.{' '}
        </p>
        <p>
          Posting regularly often helps create a demand for the items in your shop. Listing regularly doesn’t mean
          upload them all at once- you can list items once or twice a day to keep your account active and push fresh
          content in people’s feeds. This also helps keep your store in front of potential buyers who may not be
          following you.{' '}
        </p>
        <p>
          You can use Depop’s draft feature to prep your listing before publishing them on your Depop account. You may
          upload them on a specific hour where your target audience is most active to ensure that your items are being
          seen every day. This is also a great trick to keep any comments or queries about your items on top for
          potential buyers to see.{' '}
        </p>
        ​<h3>2. Invest in Great Photos </h3>​
        <p>
          Modeling and uploading great photos is the number one trick in attracting more customers to your shop. You can
          choose from flat lays, close-ups, or model shots. Some even hire professionals just to get great pictures
          because that is the power great photos uphold. Depop store with great images attract more customers and is
          proven to increase sales by 10%.{' '}
        </p>
        <p>
          Model shots get the most clicks in Depop because it gives buyers an idea of how it fits. Make sure only to use
          photos of the items you own and not from stock photos as this violates Depop policy and be removed. Also,
          using original photographs makes your shop more trustworthy. Remember to always include any signs of wear and
          tear on your photography to give your buyers an idea of what to expect once they bought the item.{' '}
        </p>
        ​
        <p>
          Another tip in ensuring that you upload great photos is by using PhotoRoom to edit the background of your
          photo. This way, buyers won’t be distracted by what is behind your item. If you plan on selling something
          expensive, be sure to upload proof of postage and other photos for authenticity. Uploading these
          certifications can boost your potential customer’s confidence in buying from your shop and trusting that the
          items are authentic.{' '}
        </p>
        ​<h3>3. Respond Quickly</h3>
        <p>
          Responding to questions quickly in the comments or direct messages can make you close the deal in no time. If
          you can’t reply to their messages immediately, make sure to get back to them within the day. Ensure that you
          have all the information needed in a handy note, such as the measurements, garment labels, and other
          information buyers may ask. If you notice that you are getting more likes than actual sales, maybe your buyers
          simply need a little push.{' '}
        </p>
        <p>
          You may send them a direct message offering a discount on bundles or combined purchases. You can also provide
          free shipping for bundle purchases to attract them to add more to their shopping cart. Leaving your
          notifications on whenever you have an active listing will enable you to respond to comments and messages
          quickly to your buyers, which can help you sell faster and keep your customers well informed.{' '}
        </p>
        ​<h3>4. Have a Shop Policy </h3>
        <p>
          Many Depop sellers don’t know how important it is to have a shop policy. Shop policies are an essential part
          when selling on Depop. Not only does it lessen repetitive question, but it also a good sign of professionalism
          and make yourself appear more trustworthy by your potential buyers. A proven trick that you can practice when
          making your shop policies is by writing it similar to a FAQ (Frequently Asked Question) and address common
          questions you get asked to.{' '}
        </p>
        ​<p>Here are some of the basic questions you should break down in your shop policy: </p>
        <ul>
          <li>Are you open to negotiations? </li>
          <li>Do you ship internationally? </li>
          <li>Are you open to trades/swaps/reservations? </li>
          <li>Return policy</li>
          <li>Shipping Timelines and Guidelines </li>
        </ul>
        ​
        <p>
          Most of the items sold in Depop are Final Sale, meaning that customers cannot return or exchange the items
          once they purchase them from your shop even if they change their mind. So you have to be thorough in
          explaining your return policy. You can highlight your shop policy on your listings or bio for your buyers and
          potential buyers to see. Also, remember to be honest on your listings all the time. Disclose any flaws or
          damages to your buyers to avoid unwanted returned items.{' '}
        </p>
        ​<h3>5. Be Open to Offers </h3>
        <p>
          As a seller, we want to make the most money on our items. The same thing goes for buyers; they want to get the
          best deal when making purchases. Your buyer may ask you if your shop is open for negotiation. Some may request
          just a little off or a discount on bundled items.{' '}
        </p>
        <p>
          The best way to make offers on Depop is always to be fair and reasonable. If you think the buyer is asking for
          an unreasonable price, reasonably explain your side on why you cannot accept his offer. Before making a deal,
          always consider the time and effort in modeling, washing, and other running costs.
        </p>
        <p>
          If you want your buyers to be more engaging to your shop, toggle the “make me offers” button so your buyers
          can make offers. Otherwise, you can also highlight on your bio, or active listing that your shop is not
          accepting negotiations and that the prices posted are fixed already.{' '}
        </p>
        <p>
          If you are receiving more likes than sales, maybe you price your items high enough for your buyers. If you are
          unsure about the price, check the market price or be open to offers. Remember only to accept offers you are
          comfortable with. If you think the price is too low for the actual item, you can always opt not to sell the
          item. As much as possible, always make it a win-win situation.{' '}
        </p>
        ​<h3>6. Use Relevant Hashtags</h3>
        <p>
          Depop is like Instagram or Twitter, in the form of a shopping app. The use of relevant hashtag is vital to
          help buyers quickly find what they are looking for. Hashtag, tags, and keywords are basically the same thing.
          This set of words is commonly used by users in finding a specific item they want to purchase. The only
          difference is that hashtag uses “#” while keywords and tags use common terms to describe an item the buyer is
          searching for.
        </p>
        <p>
          For example, a user wants to buy boyfriend jeans. She will then input in search box similar terms like
          boyfriend jeans or #boyfriendjeans. Even though you are not using hashtags on your active listing, your item
          will still be searchable as long as you use relevant terms in your description box.{' '}
        </p>
        <p>
          If you want your item to stay on top of the search box whenever someone searches with related keywords or a
          listing, it is better to maximize the usage of both the hashtag and tags. But keep in mind to avoid cluttering
          it with unrelated hashtags or spam hashtags. Aside from it doesn’t make sense, it also disqualifies you from
          being on the explore page. Try to use Google and Pinterest when looking for common hashtags use by your buyers
          and incorporate them on your description box for a higher chance of appearing on more users.{' '}
        </p>
        ​<h3>7. Optimize Your Listings </h3>
        <p>
          The trick in getting more views and sales is by having an optimized and transparent product description,
          accurate brand names, and an appropriate product image. As a seller, it is essential to be as detailed as
          possible in your product description. Make sure to describe what’s included on the image and always include
          questions buyers might ask, such as measurements, garment labels, variations, flaws, and its current
          condition.{' '}
        </p>
        <p>
          You can always direct them on your shop policy for questions such as "do you ship internationally?" or "do you
          accept negotiations for this item?." Remember that a complete and comprehensive product description also helps
          the buyer to fasten their buying decision making it more convenient for both the buyer and seller. Do not
          forget to fill out other relevant information on all fields such as attributes, categories, variations (sizes
          and colors), and other things you often get asked in your messages or comment section.{' '}
        </p>
        ​<h3>8. Be Aware of Depop Fees </h3>
        <p>
          If you are a new Depop seller, keep in mind that they charge a flat rate of 10% for every item sold. Aside
          from the Depop selling fee, there are other fees to consider, such as transaction fees, shipping labels,
          packaging, and shipping fees. You can offer bundled items with promotions such as free shipping (you will
          shoulder the shipping fee) or a discount when a buyer buys three or more items.
        </p>
        <p>
          If you are making the item, always consider the time allotted in making the item, materials, and running cost.
          The key to pricing your item right is computing the total amount it costs to make the item plus your labor
          cost. Also, Make sure you will only accept payments inside the shopping app. Avoid transacting outside the
          Depop in order to protect you from fraud and scams. Transaction outside Depop is against Depop’s terms and
          conditions, which can cause your shop to be banned. Payments made inside the Depop app also give your shop
          perks and benefits, such as showing off great feedback from your buyers.{' '}
        </p>
        ​<h3>9. Have Discounts and Promotions</h3>
        <p>
          Offer discounts on bundled items or offer free national shipping. It helps in attracting more customers
          resulting in a higher chance of selling fast. Free shipping is an excellent trick in attracting more buyers in
          adding more orders and placing the orders as soon as possible.
        </p>
        <p>
          Also, take note of the holiday seasons, whether it is Christmas, Halloween, or Black Friday. During these
          events, many buyers are looking to shop with great deals so offer discounts or promotions to attract more
          buyers. For items that aren’t selling, you can re-shoot it or let your buyers make negotiations and only deal
          with the price you are comfortable with.{' '}
        </p>
        ​<h3>10. Cross-List to Multiple Marketplaces! </h3>
        <p>
          Many marketplace sellers post their listings on multiple platforms such as Poshmark, Tradesy, and Mercari to
          broaden their market and have a higher chance of selling. The only problem with this one is selling a single
          listing and forgetting to delete it once sold. If this has been a recurring event, this may affect your
          overall reputation as a seller.{' '}
        </p>
        <p>
          Now, you can avoid this from happening and keep your reputation high! OneShop delists sold items automatically
          on separate marketplaces to save you time. With OneShop, you can quickly make drafts, post them during peak
          hours, list them on multiple marketplaces, set goals, track your business insights, and make more sales! Aside
          from our seller tools that help sellers sell faster and effectively on different marketplaces, our team also
          supports you with your marketing and picks up the best solution possible to help you sell efficiently.{' '}
        </p>
      </BlogPage>
      <Footer />
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
  },
});
